import { useEffect, useState } from "react";
import { Menu, Moon, Sun, X } from "lucide-react";
import { useTheme } from "./ThemeContext";

const links = ["About", "Skills", "Projects", "QA Work", "Contact"];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { theme, toggle } = useTheme();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (section) => {
    const id = section.toLowerCase().replace(/\s+/g, "-");
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  const bgColor = theme === "dark" ? "rgba(8, 8, 15, 0.92)" : "rgba(245, 245, 247, 0.92)";
  const mobileBg = theme === "dark" ? "rgba(8,8,15,0.98)" : "rgba(245,245,247,0.98)";

  return (
    <header
      className="fixed inset-x-0 top-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? bgColor : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: scrolled ? "1px solid var(--border)" : "none",
      }}
    >
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <button
          onClick={() => handleNav("about")}
          className="tracking-tight transition-opacity hover:opacity-70"
          style={{ fontFamily: "var(--font-mono)", fontSize: "0.875rem", color: "var(--foreground)" }}
        >
          <span style={{ color: "var(--accent)" }}>{">"}</span> ibrahim
        </button>

        <div className="hidden items-center gap-8 md:flex">
          <ul className="flex items-center gap-8">
            {links.map((link) => (
              <li key={link}>
                <button
                  onClick={() => handleNav(link)}
                  className="transition-colors"
                  style={{ fontFamily: "var(--font-sans)", fontSize: "0.8125rem", letterSpacing: "0.04em", color: "var(--muted-foreground)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--foreground)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--muted-foreground)")}
                >
                  {link}
                </button>
              </li>
            ))}
          </ul>
          <button
            onClick={toggle}
            aria-label="Toggle theme"
            className="flex h-8 w-8 items-center justify-center rounded border transition-all duration-200"
            style={{ borderColor: "var(--border)", color: "var(--muted-foreground)" }}
          >
            {theme === "dark" ? <Sun size={14} /> : <Moon size={14} />}
          </button>
        </div>

        <div className="flex items-center gap-3 md:hidden">
          <button onClick={toggle} aria-label="Toggle theme" className="flex h-8 w-8 items-center justify-center rounded border" style={{ borderColor: "var(--border)", color: "var(--muted-foreground)" }}>
            {theme === "dark" ? <Sun size={14} /> : <Moon size={14} />}
          </button>
          <button style={{ color: "var(--foreground)" }} onClick={() => setOpen((value) => !value)} aria-label="Toggle menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t md:hidden" style={{ background: mobileBg, borderColor: "var(--border)" }}>
          <ul className="flex flex-col gap-5 px-6 py-4">
            {links.map((link) => (
              <li key={link}>
                <button onClick={() => handleNav(link)} className="w-full text-left" style={{ fontFamily: "var(--font-sans)", fontSize: "0.9375rem", color: "var(--foreground)" }}>
                  {link}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
